import { useState } from "react";
import axios from "axios";
import { loadChats } from "stores/chats/chats";
import { useDispatch } from "react-redux";

const FeedbackInput = ({
  chatId,
  mssgId,
  isFeedbackSubmitted
}: {
  chatId: string;
  mssgId: string;
  isFeedbackSubmitted: string;
}) => {
  const [feedback, setFeedback] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const onInputChange = (eve: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (error) setError(false);
    const newValue = eve.target.value;

    //character has a limit of 500 character
    if (newValue.length <= 500 || newValue.length < feedback.length) {
      setFeedback(newValue);
    }
  };
  const submitFeedback = async () => {
    setIsSubmitting(true);
    try {
      const { data } = await axios.post(
        "/api/v2/chatapp/makeo/submit-feedback",
        {
          chatId: chatId,
          msgId: mssgId,
          feedBack: feedback.trim()
        }
      );
      if (data?.isSuccess) {
        setFeedback("");
        new Promise((resolve, reject) => {
          dispatch(
            loadChats({
              chatId,
              resolve,
              reject
            })
          );
        });
      }
    } catch (error: any) {
      console.log("~@@ api error", error?.message);
      setError(true);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="feedback-input-container">
      {!isFeedbackSubmitted ? (
        <>
          <textarea
            className="feedback-input"
            name="feedback"
            placeholder="Feedback"
            value={feedback}
            onChange={onInputChange}
            spellCheck={false}
          />
          <button
            type="button"
            className={`feedback-btn ${
              !feedback ? "feedback-btn-disable" : undefined
            }`}
            disabled={isSubmitting || !feedback}
            onClick={submitFeedback}
          >
            {error && feedback
              ? "something went wrong"
              : isSubmitting
              ? "submitting..."
              : "submit"}
          </button>
        </>
      ) : (
        <div className="feedback-btn feedback-btn-disable">
          Feedback is submitted, Thank you!
        </div>
      )}
    </div>
  );
};

export default FeedbackInput;
